import {ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Label } from 'recharts';
import styles from "Samarth Module/components/barAndLineComboChart/barAndLineComboChart.module.css";
const ProductionPlanComparisonGraph = ({data})=>{
    const CustomLegend = (props) => {
        const { payload } = props;
        return (
            <div style={{ display: 'flex', justifyContent: 'left', padding: '10px' }}>
                {payload.map((entry, index) => {
                    const { value, color } = entry;
                    return (
                        <span
                            key={`item-${index}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '0 10px',
                            }}
                        >
                            <span
                                style={{
                                    backgroundColor: color,
                                    width: '6px',
                                    height: '12px',
                                    display: 'inline-block',
                                    borderRadius: '2px',
                                }}
                            />
                            <span style={{ color: '#4D4D4F' }}>{value}</span>
                        </span>
                    );
                })}
            </div>
        );
    };

    const legendStyle = {
        fontSize: '10px',
        paddingTop: '15px',
        color: '#4D4D4F',
    };

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div className={styles.customTooltip}>
                    {payload.map((item, index) => (
                        <p key={index} className={styles.tooltipItem}>
                            <span style={{ fontWeight: 600 }}>{item.name}</span>&nbsp; : &nbsp;
                            {item.value}
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    return(
        <ComposedChart data={data}
			width={600}
			height={245}
			margin={{
				top: 10,
				right: 0,
				bottom: 5,
				left: 20,
			}} 
        >
            <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={true} />
            <XAxis dataKey="date" tickLine={false} axisLine={false} className={styles.BarLabel} padding={{ left: 0, right: 0 }} >
                <Label value="Past 4 Weeks" offset={10} position="bottom" style={{ fill: '#2B2B2B', fontSize: '10px', fontWeight: '500' }} />
            </XAxis>
            <YAxis domain={[0, 'auto']}  axisLine={false} padding={{ left: 0, right: 0 }}
                tick={{ 
                    fontSize: 10,           // <-- Decrease this number for smaller font
                    fill: '#2B2B2B', 
                    fontWeight: 400 
                }}
                label={{
                    value: 'Production (in tonnes)',
                    angle: -90,
                    position: 'left',
                    offset: 10,
                    style: {
                        fill: '#2B2B2B',
                        fontSize: '10px',
                        fontWeight: '500',
                        textAnchor: 'middle',
                    },
                }}
            />
            <Tooltip
                content={<CustomTooltip />}
                wrapperStyle={{
                    fontSize: '12px',
                    padding: '6px',
                }}
            />
            <Legend verticalAlign="bottom" align="left" wrapperStyle={legendStyle} content={<CustomLegend />} />

            <Bar
                radius={[4, 4, 0, 0]}
                dataKey="System plan (S1)"
                name="System plan (S1)"
                fill="#005EEF"
                barSize={15}
            />
            <Bar
                dataKey="MM plan (M1)"
                name="MM plan (M1)"
                fill="#00B190"
                barSize={15}
                radius={[4, 4, 0, 0]}
            />
            {/* <Bar
                radius={[4, 4, 0, 0]}
                dataKey="System plan (S2)"
                name="System plan (S2)"
                fill="#00b0ff"
                barSize={15}
            /> */}
            <Bar
                dataKey="MM plan (M2)"
                name="MM plan (M2)"
                fill="#1de9b6"
                barSize={15}
                radius={[4, 4, 0, 0]}
            />
            <Line type="monotone" dataKey="Actual production" name="Actual production" stroke="#f851d4ff" fill="#f851d4ff" strokeWidth={1} />
        </ComposedChart>
    );
};
export default ProductionPlanComparisonGraph;